import { RouteConfig } from "vue-router";
import { Permission } from "@/utils/permissions";

const clientRouter: Array<RouteConfig> = [
  // {
  //   path: "new_worker_account",
  //   name: "new_worker_account",
  //   component: () => import("@/views/Admins/CheckerCreate.vue"),
  //   meta: {
  //     permissionsRequired: [Permission.ADD_WORKER]
  //   }
  // },
  {
    path: "clients_list",
    name: "client_accounts",
    component: () => import("@/views/Clients/ClientList.vue"),
    meta: {
      permissionsRequired: [Permission.LIST_CLIENT]
    },
    props: true
  },
  // {
  //   path: "worker_list",
  //   name: "worker_accounts",
  //   component: () => import("@/views/Admins/SuperAdminList.vue"),
  //   meta: {
  //     permissionsRequired: [Permission.LIST_WORKER]
  //   }
  // },
  // {
  //   path: "new_account",
  //   name: "new_admin_account",
  //   component: () => import("@/views/Admins/NewSale.vue"),
  //   meta: {
  //     permissionsRequired: [Permission.ADD_ADMIN]
  //   }
  // },
  // {
  //   path: "accounts/:id",
  //   name: "adminId",
  //   component: () => import("@/views/Admins/Model.vue"),
  //   meta: {
  //     permissionsRequired: [Permission.EDIT_ADMIN]
  //   }
  // },
  {
    path: "clients_list/:id",
    name: "clientId",
    component: () => import("@/views/Clients/Client.vue"),
    meta: {
      permissionsRequired: [Permission.LIST_CLIENT]
    },
    props: true
  },
  {
    path: "",
    name: "clients",
    redirect: { name: "client_accounts" }
  }
];

export default clientRouter;
